import * as yup from 'yup';
import { emailRegex, phoneRegex } from '../../../regex';

export const schema = yup.object().shape({
  boContactPerson: yup.string().required().label('Name'),
  boInspectionEmail: yup.string().matches(emailRegex, 'Enter a valid email address').required().label('Email '),
  boInspectionPhone: yup
    .string()
    .required()
    .matches(phoneRegex, 'Invalid phone number. The phone number must be in format 2XX-XXX-XXXX')
    .label('Phone'),
});
